import * as React from 'react'

const TeamMembers = (props: { className: 'string' }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Team members' clipPath='url(#clip0)'>
          <path
            d='M 21.6 2.375L 12 2.375L 9.6 0L 2.4 0C 1.08 0 0 1.06875 0 2.375L 0 16.625C 0 17.9312 1.08 19 2.4 19L 21.6 19C 22.92 19 24 17.9312 24 16.625L 24 4.75C 24 3.44375 22.92 2.375 21.6 2.375Z'
            transform='translate(0 3)'
            id='Vector'
          />
          <path
            d='M 4 4.16667C 5.00364 4.16667 5.81091 3.23333 5.81091 2.08333C 5.81091 0.933333 5.00364 0 4 0C 2.99636 0 2.18182 0.933333 2.18182 2.08333C 2.18182 3.23333 2.99636 4.16667 4 4.16667ZM 4 5.83333C 2.66909 5.83333 0 6.6 0 8.125L 0 10L 8 10L 8 8.125C 8 6.6 5.33091 5.83333 4 5.83333Z'
            transform='translate(3 8)'
            fill='#fff'
            id='Vector_2'
          />
          <line y1='-0.5' x2='7' y2='-0.5' transform='translate(14 14)' stroke='#fff' id='Line 2' />
          <line y1='-0.5' x2='7' y2='-0.5' transform='translate(14 12)' stroke='#fff' id='Line 2.3' />
          <line y1='-0.5' x2='7' y2='-0.5' transform='translate(14 16)' stroke='#fff' id='Line 2.1' />
          <line y1='-0.5' x2='7' y2='-0.5' transform='translate(14 18)' stroke='#fff' id='Line 2.2' />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default TeamMembers



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/TeamMembers.tsx